import { render, staticRenderFns } from "./FamStack.vue?vue&type=template&id=bd1d53c2&scoped=true&lang=pug"
import script from "./FamStack.vue?vue&type=script&lang=js"
export * from "./FamStack.vue?vue&type=script&lang=js"
import style0 from "./FamStack.vue?vue&type=style&index=0&id=bd1d53c2&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd1d53c2",
  null
  
)

export default component.exports